module.exports = __webpack_public_path__ + "img/voltaje_a_red.59e69160.svg";